import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo, Breadcrumbs, breadcrumbSchema } from "@/components/Seo";
import { Reveal, SectionTag } from "@/components/Motion";
import { FinalCta } from "@/components/Cta";
import { BLOG_POSTS } from "@/data/blog";

const CRUMBS = [{ name: "首页", path: "/" }, { name: "电商资讯", path: "/blog" }];

export default function Blog() {
  return (
    <>
      <Seo
        title="TikTok Shop 马来西亚实战指南与电商资讯 | TKShopMY"
        description="写给马来西亚 TikTok Shop 卖家的实战指南：开店流程、所需资料、商品标题写法、内容规划、日常运营和常见错误。"
        path="/blog"
        schemas={[breadcrumbSchema(CRUMBS)]}
      />
      <section className="pt-28 md:pt-40 pb-14 md:pb-20" data-testid="blog-hero">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <Breadcrumbs items={CRUMBS} />
          <Reveal>
            <SectionTag>电商资讯</SectionTag>
            <h1 className="max-w-3xl font-display text-4xl font-medium leading-[1.15] text-balance sm:text-5xl">
              写给马来西亚卖家的 TikTok Shop 实战指南
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/65 md:text-lg">
              来自真实的店铺运营经验 —— 重质不重量，平台有变化我们会更新。
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="mx-auto grid max-w-6xl gap-4 px-5 md:grid-cols-2 md:px-8 lg:grid-cols-3">
          {BLOG_POSTS.map((post, i) => (
            <Reveal key={post.slug} delay={(i % 3) * 0.07}>
              <Link
                to={`/blog/${post.slug}`}
                className="group flex h-full flex-col rounded-2xl border border-ink/10 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-forest/30 hover:shadow-[0_16px_40px_rgba(16,23,17,0.08)]"
                data-testid={`blog-card-${i}`}
              >
                <p className="text-xs text-ink/45">
                  {new Date(post.date).toLocaleDateString("zh-Hans", { day: "numeric", month: "long", year: "numeric" })} · {post.readTime}
                </p>
                <h2 className="mt-3 font-display text-xl font-semibold leading-snug text-ink transition-colors group-hover:text-forest">
                  {post.title}
                </h2>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-ink/55">{post.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-forest">
                  阅读指南
                  <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <FinalCta />
    </>
  );
}
